const DownloadLoading = () => (
    <div className="fixed top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/3 bg-white border border-gray-300 rounded-md shadow-lg p-6 w-72 h-32 flex items-center justify-center space-x-3">
        <p className="text-gray-700 font-semibold text-sm">Creating Excel workbook...</p>
        <div className="loading-spinner-small"></div>
    </div>
);

export default DownloadLoading;